import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

const Styled = styled(Box)(({ theme }) => ({
  "& .gridContainer": {
    justifyContent: "end",
    marginTop: "1rem",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
      padding: "0 1rem",
    },
    "& .MuiButton-root": {
      minWidth: "auto",
      marginRight: "1rem",
      [theme.breakpoints.down("sm")]: {
        minWidth: "100%",
        marginRight: 0,
        marginBottom: "0.5rem",
      },
      "&:hover": {
        backgroundColor: undefined,
        ...theme.applyStyles("light", {
          backgroundColor: "rgba(0, 0, 0, 0.1)",
        }),
      },
    },
    "& .MuiButton-startIcon>*": {
      marginRight: "-5px",
    },
    "& .saveBtnOutlined": {
      [theme.breakpoints.down("sm")]: {
        minWidth: "100% !important",
        marginRight: 0,
      },
    },
  },
}));

export default Styled;

export const StyledBox = styled(Box)(({ theme }) => ({
  position: "relative",
  "& .categorizedView .MuiPaper-root": {
    paddingTop: "0.5rem",
    overflowX: "clip",
  },
  "& .categoryTitle": {
    fontSize: "1.1rem",
    paddingLeft: ".5rem",
  },
  "& .addBtnContainer": {
    padding: "0 1rem",
    margin: ".5rem 0",
    "& .MuiButton-root:hover": {
      backgroundColor: undefined,
      ...theme.applyStyles("light", {
        backgroundColor: "rgba(0, 0, 0, 0.1)",
      }),
    },
    "& .newRecordBtn": {
      borderWidth: "2px",
      "&:hover": {
        color: "#fff",
        background: "linear-gradient(45deg, #3ec13c 0%,#56e251 100%)",
        ...theme.applyStyles("dark", {
          background: "linear-gradient(45deg, #399837 0%,#64D55E 100%)",
        }),
      },
    },
  },
}));
